export const getReviewTypesOptions = (hasMonitorLive: boolean) => {
  const options = [
    {
      text: 'Text Posts',
      value: 'posts_text',
    },
    {
      text: 'Comments on Text Posts',
      value: 'sub_text',
    },
    {
      text: 'Video Titles-1',
      value: 'posts_video',
    },
    {
      text: 'Comments on Videos-1',
      value: 'sub_video',
    },
  ];
  if (typeof hasMonitorLive === 'boolean' && hasMonitorLive) {
    options.push(
      ...[
        { text: 'Stream Titles', value: 'stream_titles' },
        { text: 'Comments on Streams', value: 'comments_on_streams' },
        { text: 'Live Chats on Streams', value: 'live_chats_on_streams' },
      ],
    );
  }

  return options;
};
